<template>
  <WizardLayout>
    <template #title>Verify it's you!</template>

    <div class="d-flex flex-column">
      <v-form lazy-validation v-model="formValid" ref="form" @submit.prevent="onSubmit">
        <div class="ma-2 py-4 px-3 white rounded d-flex flex-column">
          <div>
            You should receive a 6 digit code.
          </div>

          <v-otp-input 
            length="6" class="mx-2"
            type="number" validate-on-blur
            v-model="verification_code"
            :rules="[required, valid_code]"
          />
          <div 
            v-if="!formValid"
            class="mx-4 red--text mt-n2" style="font-size: 12px;"
          >
            Please enter your complete 6-digit code.
          </div>


          <v-img class="mt-3" src="@/assets/wizard/proholdinghouse.png"/>

          <div class="d-flex mt-5" style="column-gap: 12px;">
            <v-spacer/>
            <v-btn @click="$router.replace({ name: 'wizard/contact'})">Back</v-btn>
            <v-btn type="submit" color="primary">Complete</v-btn>
            <v-spacer/>
          </div>
        </div>
      </v-form>

      <WizardOverlay 
        v-model="wizard_dialog"
        @close="$router.replace({ name: 'link' })"
      />

      <ErrorOverlay
        title="Oops!" v-model="error_dialog"
        :loading="false"
      >
        {{ error_message }}
      </ErrorOverlay>
    </div>
  </WizardLayout>
</template>

<script>
import { WizardLayout  } from '@/layouts'
import { WizardOverlay  } from '@/components/pages'

import ErrorOverlayMixin from '@/lib/mixins/ErrorOverlay'

import { mapActions, mapGetters } from 'vuex'
import { required, valid_code } from '@/lib/validations'

export default {
  name: 'QRVerifyView',

  mixins: [ ErrorOverlayMixin ],

  components: { WizardLayout, WizardOverlay },

  data: () => ({
    formValid: true,
    wizard_dialog: false,
    error_dialog: false,

    verification_code: '',

    // validations
    required,
    valid_code
  }),

  computed: {
    ...mapGetters('qr', ['request']),
  },

  methods: {
    ...mapActions('qr', ['createRequest', 'missingStageRequirements']),

    async onSubmit() {
      if (this.$refs.form.validate()) {
        const { verification_code } = this

        const results = await this.createRequest({ ...this.request, verification_code })

        if (results.ok) {
          this.$router.replace({ name: 'confirmation' })
        } else {
          this.error_dialog = true
          this.error_message = results.error
          this.disabled = false
        }
      }
    }
  },

  async created() {
    const result = await this.missingStageRequirements(4)
    if (result) {
      this.wizard_dialog = true
    }
  },
}
</script>